export default __webpack_public_path__ + "static/media/comment.ce9840cc.png";